<template>
  <div>
    <div class="sub-nav-box-1">
      <!-- judul halaman -->
      <h2>Dashboard Marketing</h2>
    </div>
    <!-- main view halaman -->
    <section style="margin-top: 70px; background: none" class="main-view">
      <!-- sekilas info dan grafik presensi -->
      <div class="sekilas-info-grafik-presensi">
        <!-- filter dan grafik presensi -->
        <div style="flex-direction: row" class="filter-dan-grafik">
          <!-- filter -->
          <div class="filter">
            <h5>Filter</h5>
            <!-- input cabang -->
            <div style="position: relative" class="keterangan">
              <div class="box-form email">
                <svg
                  width="14"
                  height="18"
                  viewBox="0 0 14 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13.4284 7.57115C13.4284 12.5712 6.99986 16.8569 6.99986 16.8569C6.99986 16.8569 0.571289 12.5712 0.571289 7.57115C0.571289 5.86619 1.24858 4.23105 2.45417 3.02546C3.65976 1.81987 5.2949 1.14258 6.99986 1.14258C8.70482 1.14258 10.34 1.81987 11.5455 3.02546C12.7511 4.23105 13.4284 5.86619 13.4284 7.57115Z"
                    stroke="#A0A3BD"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M6.99986 9.71401C8.18333 9.71401 9.14272 8.75462 9.14272 7.57115C9.14272 6.38768 8.18333 5.42829 6.99986 5.42829C5.81639 5.42829 4.857 6.38768 4.857 7.57115C4.857 8.75462 5.81639 9.71401 6.99986 9.71401Z"
                    stroke="#A0A3BD"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>

                <div class="input-and-title">
                  <span
                    v-if="filterEngagementRate.cabang"
                    style="display: block"
                    class="input-title"
                    >Cabang</span
                  >
                  <p>
                    {{
                      filterEngagementRate.cabang
                        ? filterEngagementRate.cabang
                        : "Cabang"
                    }}
                  </p>
                </div>
              </div>
            </div>
            <!-- end of input cabang -->
            <!-- input bulan -->
            <label tabindex="0" for="date-picker-lahir" class="box-form email">
              <svg
                width="14"
                height="16"
                viewBox="0 0 14 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.85725 0.857422V3.71456M4.14296 0.857422V3.71456M0.571533 6.57171H13.4287M2.0001 2.28599H12.0001C12.7891 2.28599 13.4287 2.92559 13.4287 3.71456V13.7146C13.4287 14.5035 12.7891 15.1431 12.0001 15.1431H2.0001C1.21113 15.1431 0.571533 14.5035 0.571533 13.7146V3.71456C0.571533 2.92559 1.21113 2.28599 2.0001 2.28599Z"
                  stroke="#A0A3BD"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <div style="position: relative" class="input-and-title">
                <input
                  style="width: 200px; height: 50px"
                  id="date-picker-lahir"
                  class="date-control"
                  type="month"
                  v-model="filterEngagementRate.bulan"
                />
                <p>
                  {{
                    filterEngagementRate.bulan
                      ? filterEngagementRate.bulan
                      : "Bulan"
                  }}
                </p>
              </div>
            </label>
            <!-- end of input bulan -->
          </div>
          <!-- end of filter -->

          <!-- grafik -->
          <div class="grafik-presensi">
            <div class="grafik-title">
              <h5>Grafik Engagement Rate</h5>
              <svg
                @click="openCloseFilterEngagementRate"
                width="20"
                height="19"
                viewBox="0 0 20 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M18.5714 1.28564H1.42859L8.28573 9.39422V15.8571L11.7143 17.5714V9.39422L18.5714 1.28564Z"
                  stroke="#4E4B66"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>

            <div class="grafik-tooltip">
              <EngagementRate
                style="width: 160px; height: 160px; margin-right: 18px"
                v-bind:cabang="userData.penempatan"
                v-bind:bulan="filterEngagementRate.bulan"
              ></EngagementRate>
              <!-- v-bind="filterEngagementRate" -->
              <!-- tooltip -->
              <div class="tooltip">
                <p>
                  <svg
                    width="8"
                    height="8"
                    viewBox="0 0 8 8"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="4" cy="4" r="4" fill="#FFCD4D" />
                  </svg>
                  <span>Diproses</span>
                </p>
                <p>
                  <svg
                    width="8"
                    height="8"
                    viewBox="0 0 8 8"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="4" cy="4" r="4" fill="#3BE3C0 " />
                  </svg>
                  <span>Diterima</span>
                </p>
                <p>
                  <svg
                    width="8"
                    height="8"
                    viewBox="0 0 8 8"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="4" cy="4" r="4" fill="#FF7666" />
                  </svg>
                  <span>Ditolak</span>
                </p>
              </div>
              <!-- end of tooltip -->
            </div>
          </div>
          <!-- end of grafik -->
        </div>
        <!-- end of filter dan grafik presensi -->
      </div>
      <!-- end of sekilas info dan grafik presensi -->

      <!-- filter presensi khusus mobile -->
      <div style="bottom: -100%" ref="filter-presensi-mobile" class="backdrop">
        <div class="filter-mobile">
          <div class="filter-mobile-title">
            <h5>Filter Grafik Presensi</h5>
            <!-- close filter -->
            <svg
              @click="openCloseFilterEngagementRate"
              width="10"
              height="10"
              viewBox="0 0 10 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.28566 0.714355L0.714233 9.28578M0.714233 0.714355L9.28566 9.28578"
                stroke="#1A1A1A"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>

          <!-- input cabang -->
          <div style="position: relative" class="keterangan">
            <div class="box-form email">
              <svg
                width="14"
                height="18"
                viewBox="0 0 14 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.4284 7.57115C13.4284 12.5712 6.99986 16.8569 6.99986 16.8569C6.99986 16.8569 0.571289 12.5712 0.571289 7.57115C0.571289 5.86619 1.24858 4.23105 2.45417 3.02546C3.65976 1.81987 5.2949 1.14258 6.99986 1.14258C8.70482 1.14258 10.34 1.81987 11.5455 3.02546C12.7511 4.23105 13.4284 5.86619 13.4284 7.57115Z"
                  stroke="#A0A3BD"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M6.99986 9.71401C8.18333 9.71401 9.14272 8.75462 9.14272 7.57115C9.14272 6.38768 8.18333 5.42829 6.99986 5.42829C5.81639 5.42829 4.857 6.38768 4.857 7.57115C4.857 8.75462 5.81639 9.71401 6.99986 9.71401Z"
                  stroke="#A0A3BD"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>

              <div class="input-and-title">
                <span
                  v-if="filterEngagementRate.cabang"
                  style="display: block"
                  class="input-title"
                  >Cabang</span
                >
                <p>
                  {{
                    filterEngagementRate.cabang
                      ? filterEngagementRate.cabang
                      : "Cabang"
                  }}
                </p>
              </div>
            </div>
          </div>
          <!-- end of input cabang -->

          <!-- input bulan -->
          <label tabindex="0" for="date-picker-lahir" class="box-form email">
            <svg
              width="14"
              height="16"
              viewBox="0 0 14 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.85725 0.857422V3.71456M4.14296 0.857422V3.71456M0.571533 6.57171H13.4287M2.0001 2.28599H12.0001C12.7891 2.28599 13.4287 2.92559 13.4287 3.71456V13.7146C13.4287 14.5035 12.7891 15.1431 12.0001 15.1431H2.0001C1.21113 15.1431 0.571533 14.5035 0.571533 13.7146V3.71456C0.571533 2.92559 1.21113 2.28599 2.0001 2.28599Z"
                stroke="#A0A3BD"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <div style="position: relative" class="input-and-title">
              <input
                style="width: 200px; height: 50px"
                id="date-picker-lahir"
                class="date-control"
                type="month"
                v-model="filterEngagementRate.bulan"
              />
              <p>
                {{
                  filterEngagementRate.bulan
                    ? filterEngagementRate.bulan
                    : "Bulan"
                }}
              </p>
            </div>
          </label>
          <!-- end of input bulan -->

          <div class="button-container">
            <button class="yellow-button">Terapkan</button>
          </div>
        </div>
      </div>
      <!-- end of filter presensi mobile -->

      <!-- filter dan grafik kehadiran karyawan -->
      <div class="filter-dan-grafik-kehadiran">
        <!-- filter -->
        <div class="filter">
          <h5>Filter</h5>
          <!-- input cabang -->
          <div style="position: relative" class="keterangan">
            <div class="box-form email">
              <svg
                width="14"
                height="18"
                viewBox="0 0 14 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.4284 7.57115C13.4284 12.5712 6.99986 16.8569 6.99986 16.8569C6.99986 16.8569 0.571289 12.5712 0.571289 7.57115C0.571289 5.86619 1.24858 4.23105 2.45417 3.02546C3.65976 1.81987 5.2949 1.14258 6.99986 1.14258C8.70482 1.14258 10.34 1.81987 11.5455 3.02546C12.7511 4.23105 13.4284 5.86619 13.4284 7.57115Z"
                  stroke="#A0A3BD"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M6.99986 9.71401C8.18333 9.71401 9.14272 8.75462 9.14272 7.57115C9.14272 6.38768 8.18333 5.42829 6.99986 5.42829C5.81639 5.42829 4.857 6.38768 4.857 7.57115C4.857 8.75462 5.81639 9.71401 6.99986 9.71401Z"
                  stroke="#A0A3BD"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>

              <div class="input-and-title">
                <span
                  v-if="filterTingkatAktivitas.cabang"
                  style="display: block"
                  class="input-title"
                  >Cabang</span
                >
                <p>
                  {{
                    filterTingkatAktivitas.cabang
                      ? filterTingkatAktivitas.cabang
                      : "Cabang"
                  }}
                </p>
              </div>
            </div>
          </div>
          <!-- end of input cabang -->

          <!-- input tahun -->
          <div
            style="position: relative; margin-right: 12px"
            class="keterangan"
          >
            <div
              @click="openClosePilihanTahunAktivitas(true)"
              class="box-form email"
            >
              <svg
                width="14"
                height="18"
                viewBox="0 0 14 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.4284 7.57115C13.4284 12.5712 6.99986 16.8569 6.99986 16.8569C6.99986 16.8569 0.571289 12.5712 0.571289 7.57115C0.571289 5.86619 1.24858 4.23105 2.45417 3.02546C3.65976 1.81987 5.2949 1.14258 6.99986 1.14258C8.70482 1.14258 10.34 1.81987 11.5455 3.02546C12.7511 4.23105 13.4284 5.86619 13.4284 7.57115Z"
                  stroke="#A0A3BD"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M6.99986 9.71401C8.18333 9.71401 9.14272 8.75462 9.14272 7.57115C9.14272 6.38768 8.18333 5.42829 6.99986 5.42829C5.81639 5.42829 4.857 6.38768 4.857 7.57115C4.857 8.75462 5.81639 9.71401 6.99986 9.71401Z"
                  stroke="#A0A3BD"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>

              <div class="input-and-title">
                <span
                  v-if="filterTingkatAktivitas.tahun"
                  style="display: block"
                  class="input-title"
                  >Tahun</span
                >
                <p>
                  {{
                    filterTingkatAktivitas.tahun
                      ? filterTingkatAktivitas.tahun
                      : "Tahun"
                  }}
                </p>
              </div>
            </div>
            <!-- box pilihan tahun -->
            <div
              style="display: none"
              ref="pilihan-tahun-aktivitas"
              class="box-pilihan"
            >
              <p @click="openClosePilihanTahunAktivitas(false, 2021)">2021</p>
              <p @click="openClosePilihanTahunAktivitas(false, 2022)">2022</p>
              <p @click="openClosePilihanTahunAktivitas(false, 2023)">2023</p>
            </div>
            <!-- end of box pilihan tahun -->
          </div>
          <!-- end of input tahun -->
        </div>
        <!-- end of filter -->
        <div class="grafik-kehadiran">
          <div class="grafik-title">
            <h5>Grafik Tingkat Aktivitas</h5>
            <p>
              <svg
                width="8"
                height="8"
                viewBox="0 0 8 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="4" cy="4" r="4" fill="#00BA88" />
              </svg>
              <span>Wonosari</span>
            </p>
          </div>
          <TingkatAktivitas
            v-bind:cabang="userData.penempatan"
            v-bind:tahun="filterTingkatAktivitas.tahun"
          ></TingkatAktivitas>
        </div>
      </div>
      <!-- filter dan grafik kehadiran karyawan -->

      <!-- grafik kehadiran mobile -->
      <div class="grafik-kehadiran-mobile">
        <div class="grafik-title">
          <!-- judul dan legend -->
          <div class="title-and-legend">
            <h5 style="margin-bottom: 6px">Grafik Tingkat Aktivitas</h5>
            <p>
              <svg
                width="8"
                height="8"
                viewBox="0 0 8 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="4" cy="4" r="4" fill="#00BA88" />
              </svg>
              <span>Wonosari</span>
            </p>
          </div>
          <!-- end of judul dan legend -->

          <!-- filter button -->
          <svg
            @click="openCloseFilterTingkatAktivitas"
            width="20"
            height="19"
            viewBox="0 0 20 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18.5714 1.28564H1.42859L8.28573 9.39422V15.8571L11.7143 17.5714V9.39422L18.5714 1.28564Z"
              stroke="#4E4B66"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <!-- end of filter button -->
        </div>
        <TingkatAktivitasMobile
          v-bind:cabang="userData.penempatan"
          v-bind:tahun="filterTingkatAktivitas.tahun"
        ></TingkatAktivitasMobile>
      </div>
      <!-- end of grafik kehadiran mobile -->

      <!-- filter kehadiran khusus mobile -->
      <div style="bottom: -100%" ref="filter-kehadiran-mobile" class="backdrop">
        <div class="filter-mobile">
          <div class="filter-mobile-title">
            <h5>Filter Grafik Tingkat Aktivitas</h5>
            <!-- close filter -->
            <svg
              @click="openCloseFilterTingkatAktivitas"
              width="10"
              height="10"
              viewBox="0 0 10 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.28566 0.714355L0.714233 9.28578M0.714233 0.714355L9.28566 9.28578"
                stroke="#1A1A1A"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>

          <!-- input cabang -->
          <div style="position: relative" class="keterangan">
            <div class="box-form email">
              <svg
                width="14"
                height="18"
                viewBox="0 0 14 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.4284 7.57115C13.4284 12.5712 6.99986 16.8569 6.99986 16.8569C6.99986 16.8569 0.571289 12.5712 0.571289 7.57115C0.571289 5.86619 1.24858 4.23105 2.45417 3.02546C3.65976 1.81987 5.2949 1.14258 6.99986 1.14258C8.70482 1.14258 10.34 1.81987 11.5455 3.02546C12.7511 4.23105 13.4284 5.86619 13.4284 7.57115Z"
                  stroke="#A0A3BD"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M6.99986 9.71401C8.18333 9.71401 9.14272 8.75462 9.14272 7.57115C9.14272 6.38768 8.18333 5.42829 6.99986 5.42829C5.81639 5.42829 4.857 6.38768 4.857 7.57115C4.857 8.75462 5.81639 9.71401 6.99986 9.71401Z"
                  stroke="#A0A3BD"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>

              <div class="input-and-title">
                <span
                  v-if="filterTingkatAktivitas.cabang"
                  style="display: block"
                  class="input-title"
                  >Cabang</span
                >
                <p>
                  {{
                    filterTingkatAktivitas.cabang
                      ? filterTingkatAktivitas.cabang
                      : "Cabang"
                  }}
                </p>
              </div>
            </div>
          </div>
          <!-- end of input cabang -->

          <!-- input tahun -->
          <div
            style="position: relative; margin-right: 12px"
            class="keterangan"
          >
            <div
              @click="openClosePilihanTahunAktivitas(true)"
              class="box-form email"
            >
              <svg
                width="14"
                height="18"
                viewBox="0 0 14 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.4284 7.57115C13.4284 12.5712 6.99986 16.8569 6.99986 16.8569C6.99986 16.8569 0.571289 12.5712 0.571289 7.57115C0.571289 5.86619 1.24858 4.23105 2.45417 3.02546C3.65976 1.81987 5.2949 1.14258 6.99986 1.14258C8.70482 1.14258 10.34 1.81987 11.5455 3.02546C12.7511 4.23105 13.4284 5.86619 13.4284 7.57115Z"
                  stroke="#A0A3BD"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M6.99986 9.71401C8.18333 9.71401 9.14272 8.75462 9.14272 7.57115C9.14272 6.38768 8.18333 5.42829 6.99986 5.42829C5.81639 5.42829 4.857 6.38768 4.857 7.57115C4.857 8.75462 5.81639 9.71401 6.99986 9.71401Z"
                  stroke="#A0A3BD"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>

              <div class="input-and-title">
                <span
                  v-if="filterTingkatAktivitas.tahun"
                  style="display: block"
                  class="input-title"
                  >tahun</span
                >
                <p>
                  {{
                    filterTingkatAktivitas.tahun
                      ? filterTingkatAktivitas.tahun
                      : "Tahun"
                  }}
                </p>
              </div>
            </div>
            <!-- box pilihan tahun -->
            <div
              style="display: none"
              ref="pilihan-tahun-aktivitas-mobile"
              class="box-pilihan"
            >
              <p @click="openClosePilihanTahunAktivitas(false, 2021)">2021</p>
              <p @click="openClosePilihanTahunAktivitas(false, 2022)">2022</p>
              <p @click="openClosePilihanTahunAktivitas(false, 2023)">2023</p>
            </div>
            <!-- end of box pilihan tahun -->
          </div>
          <!-- end of input tahun -->

          <div class="button-container">
            <button class="yellow-button">Terapkan</button>
          </div>
        </div>
      </div>
      <!-- end of filter kehadiran mobile -->
    </section>
    <!-- end of main view halaman -->
  </div>
</template>

<script>
import { mapState } from "vuex";
import EngagementRate from "@/components/marketing/grafik/EngagementRate";
import TingkatAktivitas from "@/components/marketing/grafik/TingkatAktivitas";
import TingkatAktivitasMobile from "@/components/marketing/grafik/TingkatAktivitasMobile";

export default {
  components: {
    EngagementRate,
    TingkatAktivitas,
    TingkatAktivitasMobile,
  },

  data() {
    return {
      // data untuk filter presensi
      filterEngagementRate: {
        cabang: "",
        bulan: new Date().toISOString().slice(0, 7),
      },
      // data untuk filter kehadiran
      filterTingkatAktivitas: {
        cabang: "",
        tahun: parseInt(new Date().toISOString().slice(0, 4)),
      },
    };
  },

  mounted() {
    this.filterEngagementRate.cabang = this.userData.penempatan;
    this.filterTingkatAktivitas.cabang = this.userData.penempatan;
  },

  methods: {
    // untuk tutup atau buku box pilihan
    openClosePilihanCabangPresensi(open, value) {
      let box = this.$refs["pilihan-cabang-presensi"];
      let boxMobile = this.$refs["pilihan-cabang-presensi-mobile"];
      if (open) {
        box.style.display = "block";
        boxMobile.style.display = "block";
      } else {
        this.filterEngagementRate.cabang = value != "Semua" ? value : "";
        box.style.display = "none";
        boxMobile.style.display = "block";
      }
    },

    openClosePilihanCabangTingkatAktivitas(open, value) {
      let box = this.$refs["pilihan-cabang-kehadiran"];
      let boxMobile = this.$refs["pilihan-cabang-kehadiran-mobile"];
      if (open) {
        box.style.display = "block";
        boxMobile.style.display = "block";
      } else {
        this.filterTingkatAktivitas.cabang = value != "Semua" ? value : "";
        box.style.display = "none";
        boxMobile.style.display = "none";
      }
    },

    openClosePilihanTahunAktivitas(open, value) {
      let box = this.$refs["pilihan-tahun-aktivitas"];
      let boxMobile = this.$refs["pilihan-tahun-aktivitas-mobile"];
      if (open) {
        box.style.display = "block";
        boxMobile.style.display = "block";
      } else {
        box.style.display = "none";
        boxMobile.style.display = "none";
        this.filterTingkatAktivitas.tahun = value;
      }
    },

    // untuk filter mobile
    openCloseFilterEngagementRate() {
      let box = this.$refs["filter-presensi-mobile"];
      if (box.style.bottom === "0px") {
        box.style.bottom = "-100%";
      } else box.style.bottom = "0px";
    },

    openCloseFilterTingkatAktivitas() {
      let box = this.$refs["filter-kehadiran-mobile"];
      if (box.style.bottom === "0px") {
        box.style.bottom = "-100%";
      } else box.style.bottom = "0px";
    },
  },

  computed: {
    ...mapState(["userData", "listPenempatan", "listDivisi"]),
  },
};
</script>
